import './pedido.css';

import {

  Button,
  Card,
  Col,
  Icon,
  Row,
  TextInput,
  Textarea,

} from 'react-materialize';

import AsyncSelect from 'react-select/async';
import React from 'react';
import Swal from 'sweetalert2';
import { ErpConnect as qad } from '../../../services';
import axios from 'axios';
import debounce from 'lodash/debounce';

// import M from 'materialize-css';




class PedidoView extends React.Component {
  state = {
    targetElementOffer: '',
    targetControlOffer: '',
    targetElementPrice: '',
    targetControlPrice: ''
  };

  user = JSON.parse(localStorage.getItem('user'));
  
  customers = [];

  componentDidMount = async () => {
    this.props.productos.forEach((producto) => {
      this.props.cambiarCantidad(producto.cantidad, producto);
    });
    /*const agentes = await qad.catalog.salesPerson.all();
    this.setState({
      agentes,
    });*/
  };

  filterOptions = (inputValue) => {
    if ( inputValue.length > 3 )
    {
      this.filtredCustomers = this.customers.filter((i) =>{
          return i.label.toLowerCase().includes(inputValue.toLowerCase())
        }
      );
    }
    else
    {
      if ( inputValue.length > 3 )
      {
        this.filtredCustomers = this.customers.filter((i) =>{
            return i.label.toLowerCase().includes(inputValue.toLowerCase())
          }
        );
      }
      else
      {
        this.filtredCustomers = this.customers.slice(0, 500).filter((i) =>{
            return i.label.toLowerCase().includes(inputValue.toLowerCase())
          }
        );
      }
    }
    return this.filtredCustomers;
  }
/*
  promiseOptions = (inputValue) => {
    return new Promise ((resolve) => {
      resolve(this.filterOptions(inputValue));
    });
  }
*/
  promiseOptions = debounce((inputValue, callback) => {
    const q = (inputValue || '').trim();

    if (q.length < 3) {
      this.setState({ noResults: false });
      callback([]);
      return;
    }

    axios
      .get('/api/clients/search', {
        params: {
          q,
          includeInactive: 0
        }
      })
      .then(res => {
        const data = Array.isArray(res.data) ? res.data : [];
        this.setState({ noResults: data.length === 0 });
        callback(data);
      })
      .catch(() => {
        this.setState({ noResults: true });
        callback([]);
      });
  }, 600);

  render() {
    const user = JSON.parse(localStorage.getItem("user"));  
    let iva = 0;
    console.log(iva); //no marcara que la variable no esta en uso
    let subtotal = 0;
    this.customers = this.props.catalog.customers.map( (el)=> { return {"value": el.id, "label": el.id +" - "+ el.name+ " - " + el.billingRfc, "priceList": el.pricesList } } );
   
    return (
      <React.Fragment>
        <Row>
          <Col>
            <h6>
              Vendedor:{' '}
              <a
                href="#/"
                onClick={async () => {
                  if(!this.state.agentes)
                  {
                    return;
                  }
                  let options = {};
                  for (let i = 0; i < this.state.agentes.length; i++) {
                    options[String(this.state.agentes[i].id)] = String(
                      this.state.agentes[i].name
                    );
                  }
                  await Swal.fire({
                    title: 'Cambio de vendedor',
                    text: 'selecciona un vendedor',
                    input: 'select',
                    inputOptions: options,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Aceptar',
                  }).then((response) => {
                    if (response.isConfirmed) {
                      let selectedVendedor = this.state.agentes.filter(
                        (value) => {
                          return response.value === value.id;
                        }
                      );
                      this.props.setNuevoAgente(selectedVendedor[0]);
                    }
                  });
                }}
              >
                {this.props.newAgente
                  ? this.props.newAgente.name
                  : this.user.name}
              </a>
            </h6>
          </Col>
          {
            ( true )
            ?
              ""
            :
            <Col>
            <Button
              large
              onClick={async (event) => {
                try {
                  console.log("Pedidos masivos iniciado");
                  const arrayOfOrders = (new Array(50)).fill(10);
          
                  // para hacer que mainPromise haga algo y no sea warning
                  const mainPromise = new Promise(async (mainResolve) => {
                    let orders = [];
                    await Promise.all(
                      arrayOfOrders.map(async (number) => {
                        let randCustomer = Math.floor(Math.random() * this.customers.length);  
                        let customer = this.customers[randCustomer];
                        let min = 1;
                        let max = 10;
                        let randLine = Math.floor(Math.random() * (max - min + 1) + min);
                        const arrayOfLines = (new Array(randLine)).fill(1);
                        const lines = await Promise.all(
                          arrayOfLines.map(async (nLine) => {
                            let randProduct = Math.floor(Math.random() * this.props.catalog.products.length);
                            let productId = this.props.catalog.products[randProduct].id;
                            const priceList = await qad.catalog.priceList.findByProductId(productId);
                            let priceFromList = priceList.filter((pl) => pl.id === customer.priceList);
                            if (priceFromList.length <= 0) {
                              priceFromList = priceList;
                            }
                            return {
                              customerId: customer.value,
                              productId,
                              quantity: Math.floor(Math.random() * 10),
                              price: priceFromList[0].price,
                            };
                          })
                        );
          
                        let salesOrder = {
                          customerId: customer.value,
                          shippingAddressId: customer.value, // TODO: Update shippingAddressId
                          siteId: '3000',
                          remarks: 'Massive salesOrderId',
                          salesPersonId: 'VRAL',
                          source: 'POS',
                          appId: 'N/A',
                          lines,
                        };
          
                        const orderCreated = await qad.catalog.salesOrder.create(salesOrder);
                        let orderRemision = null;
                        if (orderCreated && orderCreated.salesOrderId) {
                          orderRemision = await qad.catalog.salesOrder.toRemision(orderCreated.salesOrderId);
                        }
                        console.log(orderCreated, orderRemision);
                        let objRet = { salesOrder, backOrder: orderCreated, orderRemisionId: orderRemision };
                        orders.push(objRet);
                        return objRet;
                      })
                    );
          
                    console.log("arrayOfOrdersPromises", JSON.stringify(orders));
                    mainResolve(orders); // Resolviendo la promesa con los pedidos creados
                  });
          
                  // Resultado del "mainPromise"
                  const resolvedOrders = await mainPromise;
                  console.log("ordersPromises", JSON.stringify(resolvedOrders));
          
                } catch (error) {
                  console.error(error);
                }
                console.log("Pedidos masivos finalizado");
              }}
            >
              Pedidos Masivos
            </Button>
          </Col>
          }
          <Col xl={12} l={12} m={12} s={12}>
            <Card>
              <Row>
                {this.props.productosLocalStorage.length > 0 ? (
                  <div>
                    <Col
                      xl={12}
                      l={12}
                      m={12}
                      s={12}
                      className="center button-top-pedido"
                    >
                      <Col xl={6} l={6} m={6} s={6}>
                        <h6 className="envio-pregunta">
                          Selecciona el cliente
                        </h6>
                       <AsyncSelect 
                          placeholder="Clientes"
                          cacheOptions
                          isClearable
                          value={this.props.cliente}

                          onChange={(value) => {
                            this.props.seleccionarCliente(value);
                            this.setState({ inputValue: '' });
                          }}
                          loadOptions={this.promiseOptions}
                          defaultOptions={false}
                          loadingMessage={() => 'Se están cargando los clientes, espere un momento'}
                          inputValue={this.state.inputValue}
                          onInputChange={(value, { action }) => {
                            if (action === 'input-change') {
                            this.setState({ inputValue: value });
                            }
                          }}

                          onBlur={() => this.setState({ inputValue: '' })}

                          noOptionsMessage={() =>
                            this.state.noResults
                              ? 'No se encontró ningún resultado'
                              : 'Escribe al menos 3 caracteres'
                          }
                        />
                          {
                            (this.props.clienteSeleccionado && this.props.clienteSeleccionado.billingAddress ) 
                            ? 
                              <div>
                                <label>Direccion:</label>
                                <div>
                                  <b>{this.props.clienteSeleccionado.billingAddress}</b>, {this.props.clienteSeleccionado.billingZipCode}, {this.props.clienteSeleccionado.billingCity}, {this.props.clienteSeleccionado.billingState}
                                </div>
                              </div>
                            :
                              null
                          }
                      </Col>
                      <Col xl={6} l={6} m={6} s={6}>
                        <h6 className="envio-pregunta">
                          ¿Necesitas envio para tu compra? (Opcional)
                        </h6>

                        <select
                          value={this.props.envioSeleccionado}
                          className="combo-pedido"
                          onChange={this.props.onSelectEnvio}
                        >
                          <option value="0">Selecciona tu envio</option>
                          {this.props.envios.map((envio, key) => (
                            <option value={envio.id} key={key + 1}>
                              {envio.desc_prod +
                                (envio.desc_med ? ' ' + envio.desc_med : '')}
                            </option>
                          ))}
                        </select>
                        <Button
                          medium="true"
                          className="button-pedido"
                          onClick={(event) => {
                            this.props.agregarEnvio(
                              this.props.envioSeleccionado
                            );
                          }}
                        >
                          Agregar envio
                        </Button>
                      </Col>
                    </Col>
                    <Col
                      xl={12}
                      l={12}
                      m={12}
                      s={12}
                      className="center button-top-pedido"
                    >

<Col xl={6} l={6} m={6} s={6}>
  {(() => {
   const max = 235;
   const len = this.props.comentarioPedido?.length || 0;
   const warnAt = Math.floor(max * 0.9);
      const state = len >= warnAt ? "warn" : "ok";
   

    return (
      <div className={`comentarios-wrap comentarios-wrap--${state}`}>
        <Textarea
          label="¿Deseas agregar comentarios al pedido? (Opcional)"
          xl={12}
          l={12}
          m={12}
          s={12}
          value={this.props.comentarioPedido}
          maxLength={max}
          onChange={this.props.onChangeComentarioPedido}
          onFocus={() =>
            this.props.setActiveInput(
              `comentarios`,
              "spanish",
              "comentarios",
              this.props.comentarioPedido
            )
          }
        />
        <div className={`comentarios-counter comentarios-counter--${state}`}>
          {len}/{max}
        </div>
      </div>
    );
  })()}
</Col>

                      <Col xl={6} l={6} m={6} s={6} className="hidden">
                        <TextInput
                          label="¿El pedido necesita descuento? (Opcional)"
                          type="number"
                          xl={12}
                          l={12}
                          m={12}
                          s={12}
                          min={1}
                          value={this.props.descuentoPedido}
                          onChange={this.props.onChangeDescuento}
                          onFocus={() =>
                            this.props.setActiveInput(
                              `descuento`,
                              'number',
                              'descuento',
                              this.props.descuentoPedido
                            )
                          }
                        />
                      </Col>
                    </Col>

                    <Col
                      xl={12}
                      l={12}
                      m={12}
                      s={12}
                      className="center button-top-pedido"
                    >
                      {["002", "003","001", "005" ,"008"].includes(user?.departmentId) && (
                       <Button
                        large
                        onClick={(event) => {
                            const productos = JSON.parse(localStorage.getItem('productosLocalStorage'));
                            console.log(productos,this.props.comentarioPedido);
                            this.props.cambioPrecio(productos,this.props.comentarioPedido);
                        }}
                      >
                        Solicitar cambio de precio
                      </Button>
                       )}
                      &nbsp;&nbsp;&nbsp;&nbsp;

                      <Button
                        large
                        onClick={(event) => {
                          this.props.colocarPedido(
                            this.props.productosLocalStorage,
                            false
                          );
                        }}
                      >
                        Colocar Pedido sin Remision
                      </Button>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <Button large onClick={this.props.regresarArticulos}>
                        Regresar a los articulos
                      </Button>{' '}
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <Button
                        large
                        onClick={(event) => {
                          const productosActualizados = JSON.parse(localStorage.getItem('productosLocalStorage'));
                          this.props.colocarPedido(productosActualizados);
                        }}
                      >
                        Colocar Pedido
                      </Button> 
                    </Col>
                    <Col
                      xl={12}
                      l={12}
                      m={12}
                      s={12}
                      className="center-align button-top-pedido"
                    >
                      <h5 className="titulo-pedido">Articulos del pedido</h5>
                    </Col>
                    <Col xl={12} l={12} m={12} s={12}>
                      <table className="striped center highlight tablePedido">
                        <thead>
                          <tr>
                            {/* 21% de espacio disponible */}
                            <th style={{ width: '30%' }}>Articulo</th>
                            <th style={{ width: '10%', textAlign: 'center' }}>
                              Talla
                            </th>
                            <th style={{ width: '10%' }}>Color</th>
                            <th style={{ width: '10%' }}>Cantidad</th>
                            <th style={{ width: '25%' }}>Precio</th>
                            {/* <th style={{ width: '18%' }}>Descuento</th> */}
                            <th style={{ width: '15%' }}>Acciones</th>
                          </tr>
                        </thead>
                        <tbody className="z-depth-2">
                          {this.props.productosLocalStorage.map((producto, index) => {

                            subtotal += parseFloat(producto.prec_prod) * parseInt(producto.cantidad);
                            iva += parseFloat(subtotal) * 0.16;

                            const tieredPricing = JSON.parse(localStorage.getItem("cat_tiered_pricing")) || [];
                            const modelo = producto.modeloId;
                            const category = producto.categoryId; 
                            const colorIdActual =  producto.colorId;
                            const escalonado = tieredPricing.find(item => item.ListId === modelo);
                            const promocion = tieredPricing.find(
                              item =>
                                item.ListId === producto.brandId &&
                                item.categoryId === category &&
                                item.typeList === "3" &&
                                (
                                  item.colorId === "" || 
                                  item.colorId.split(",").includes(colorIdActual)
                                )
                            );

                            let nuevoPrecioNumerico = null;
                            let nuevoPrecio = null;
                            let priceListIdSet = null;

                              if (!promocion && !escalonado) {
                              const cantidadesPorMarca = {};

                              this.props.productosLocalStorage.forEach(p => {
                                const marca = p.brandId;
                                const cantidad = parseInt(p.cantidad || 0, 10);
                                cantidadesPorMarca[marca] = (cantidadesPorMarca[marca] || 0) + cantidad;
                              });

                              const MARCAS_MAYOREO_COMPARTIDO = ['MA16', 'MA24'];

                              const totalMarcasCompartidas = MARCAS_MAYOREO_COMPARTIDO.reduce(
                                (total, marcaId) => total + (cantidadesPorMarca[marcaId] || 0),
                                0
                              );
                              let totalMarca;

                              if (MARCAS_MAYOREO_COMPARTIDO.includes(producto.brandId)) {
                                totalMarca = totalMarcasCompartidas;
                              } else {
                                totalMarca = cantidadesPorMarca[producto.brandId] || 0;
                              }

                              const precioMayoreo = producto.priceList?.find(p => p.id === "MAYOREO")?.price;
                              const precioMenudeo = producto.priceList?.find(p => p.id === "MENUDEO")?.price;
                              const precioYelos = producto.priceList?.find(p => p.id === "OTRO")?.price;
                              

                              const clientePriceList = this.props.clienteCompleto?.pricesList ?? "MENUDEO";

                              let usarMayoreo = false;
                              let usarYelos = false;

                              const yaTieneMayoreo = priceListIdSet === "MAYOREO";
                              /*
                              console.log('totalMarca',totalMarca,
                                  'clientePriceList',clientePriceList,
                                  'yaTieneMayoreo',yaTieneMayoreo
                              );
                              */
                             //console.log('clientePriceList', clientePriceList);
                             
                              if (clientePriceList === "MAYOREO") {
                                usarMayoreo = true;
                              }else if (clientePriceList === "MENUDEO" || clientePriceList === undefined) {
                                if (totalMarca >= 12) {
                                  usarMayoreo = true;
                                } else if (yaTieneMayoreo) {
                                  usarMayoreo = false;
                                }
                              }
                              if(precioYelos !== undefined && clientePriceList === "YELOS"){
                                usarYelos = true;
                              }else if(clientePriceList === "YELOS"){
                                usarMayoreo = true;
                              }

                               
                              if (usarMayoreo) {
                                nuevoPrecioNumerico = parseFloat(precioMayoreo);
                                nuevoPrecio = nuevoPrecioNumerico.toFixed(2);
                                priceListIdSet = "MAYOREO";
                              } else if (usarYelos) {
                                nuevoPrecioNumerico = parseFloat(precioYelos);
                                nuevoPrecio = nuevoPrecioNumerico.toFixed(2);
                                priceListIdSet = "YELOS";
                              } else {
                                nuevoPrecioNumerico = parseFloat(precioMenudeo);
                                nuevoPrecio = nuevoPrecioNumerico.toFixed(2);
                                priceListIdSet = "MENUDEO";
                              }
                              if (nuevoPrecio !== null && producto.prec_prod !== nuevoPrecio) {
                                //console.log('Entra updateProduct');
                                const updatedProduct = {
                                  ...producto,
                                  prec_set: nuevoPrecioNumerico,
                                  prec_prod: nuevoPrecio,
                                  priceListIdSet: priceListIdSet,
                                };
                              
                                setTimeout(() => {
                                  this.props.setPriceProductosLocalStorage(updatedProduct, index);
                                }, 0);
                              }
                            }

                            


                            return (
                              <tr key={index}>
                                <td>{producto.descripcion}</td>
                                <td>{producto.talla}</td>
                                <td>
                                  {(producto.color || '').toUpperCase()}
                                </td>
                                <td>
                                  <TextInput
                                    className="input-pedido"
                                    placeholder="Ingresa la cantidad"
                                    type="number"
                                    min={1}
                                    value={`${producto.cantidad}`}
                                    onChange={(event) => {
                                      this.props.cambiarCantidad(
                                        event.target.value,
                                        producto
                                      );
                                    }}
                                    onFocus={() =>
                                      this.props.setActiveInput(
                                        `cantidad-${index}`,
                                        'number',
                                        'pedido',
                                        producto
                                      )
                                    }
                                  />

                                </td>
                                <td>
                              <select
                                style={{ width: '150px' }}
                                className="combo-pedido"
                                disabled
                               value={(() => {
                                const tieredPricing = JSON.parse(localStorage.getItem("cat_tiered_pricing")) || [];
                                const modelo = producto.modeloId;
                                const category = producto.categoryId;

                                const escalonado = tieredPricing.some(
                                  item => item.ListId === modelo && item.typeList === "3"
                                );

                               
                                    const promocion = tieredPricing.find(

                                      item =>
                                      (item.ListId === producto.brandId &&
                                        item.categoryId === category &&
                                        item.typeList === "3" &&
                                        ((
                                          item.colorId === "" || 
                                          item.colorId.split(",").includes(colorIdActual)
                                        )
                                        ||
                                        (
                                          item.ListId === producto.modeloId &&
                                          item.typeList === "2"
                                        ))
                                    ));


                                if (escalonado) {
                                  return "escalonado";
                                }

                                if (promocion) {
                                  return "promo";
                                }
                              /*
                              const clientePriceList = this.props.clienteCompleto?.pricesList; 
                                  
                              if (producto.priceList && clientePriceList) {
                                const match = producto.priceList.find(p => p.id === clientePriceList);
                                if (match) {
                                  return match.id;
                                }
                              }
                                */
                              })()}
                              >
                           {(() => {
                              const tieredPricing = JSON.parse(localStorage.getItem("cat_tiered_pricing")) || [];
                              const modelo = producto.modeloId;
                              const category = producto.categoryId;
                              
                              const colorIdActual = producto.colorId;
                              const escalonado = tieredPricing.some(item => item.ListId === modelo && item.typeList === "1");
                              const escalonado4 = tieredPricing.some(item => item.ListId === modelo && item.typeList === "4");
                              const escalonadoPellones = tieredPricing.some(item => item.ListId === modelo && item.typeList === "2");
                              const promocion = tieredPricing.some(item =>
                                (item.ListId === producto.brandId &&
                                item.categoryId === category &&
                                item.typeList === "3" &&
                                (item.colorId === "" || item.colorId.split(",").includes(colorIdActual))) ||
                                (item.ListId === producto.modeloId &&
                                item.typeList === "2")
                            );
                              //console.log('modelo:', modelo); 
                              if (escalonado) {
                               //console.log('Escalonado');
                                  return (
                                    <option value="escalonado">
                                      $ {parseFloat(producto.prec_set).toFixed(2)} (Morrales)
                                    </option>
                                  );
                              }
                              if (escalonado4) {
                                //console.log(this.props.clienteCompleto.region);
                                producto.priceListIdSet ='escalonado4';
                                  return (
                                    <option value="escalonado4">
                                      $ {parseFloat(producto.prec_set).toFixed(2)} (VLANK)
                                    </option>
                                  );
                              }
                              if (escalonadoPellones) {
                                //console.log('Escalonado Pellones');
                                  return (
                                    <option value="escalonadoPellones">
                                      $ {parseFloat(producto.prec_set).toFixed(2)} (Promo)
                                    </option>
                                  );
                              }

                              if (promocion) {
                                //console.log('Promocion');
                                return (
                                  <option value="promocion">
                                    $ {parseFloat(producto.prec_set).toFixed(2)} (Promo)
                                  </option>
                                );
                              }

                              if(!promocion && !escalonado ){
                               // const clientePriceList = this.props.clienteCompleto?.pricesList;
                                //const precioActual = String(producto.prec_set);

                                /*const precioCoincidente = producto.priceList.find(p => {
                                  const precioIgual = String(p.price) === precioActual;
                                  const listaIgual = clientePriceList ? p.id === clientePriceList : true;
                                  return precioIgual && listaIgual;
                                   
                                });*/
                              // console.log('priceListIdSet', producto.priceListIdSet);
                                return producto.priceList.map((priceList, index) => (
                                  <option key={index} value={producto.priceListIdSe}>
                                    { `$ ${producto.prec_set} (${producto.priceListIdSet})`}
                                  </option>
                                ));
                              }
                              })()}

                              </select>
                                </td>
                                <td>
                                  <Button
                                    className="red lighten-1"
                                    onClick={(event) => {
                                      this.props.eliminarPartida(producto);
                                    }}
                                  >
                                    <Icon className="white-icon-pedido">
                                      remove_circle
                                    </Icon>
                                  </Button>
                                </td>
                              </tr>
                            );
                          }
                          )}
                        </tbody>
                      </table>
                    </Col>
                    <Col
                      xl={12}
                      l={12}
                      m={12}
                      s={12}
                      className="button-top-pedido"
                    >
                      <Row>
                        <br />
                        <br />
                        <Col xl={12} l={12} m={12} s={12}>
                          <div className="title text-blue">{`SUB TOTAL: $ ${parseFloat(this.props.total).toFixed(2)}`}</div>
                          {/* <div className="title text-blue">{`Descuento: $ ${descuento}`}</div> */}
                          <div className="title text-blue">{`IVA: $ ${parseFloat(this.props.total*0.16).toFixed(2)}`}</div>
                          <div className="title text-blue">{`TOTAL: $ ${parseFloat(this.props.total*1.16).toFixed(2)}`}</div>
                          <div className="title text-blue">Total de piezas: {this.props.productosLocalStorage.reduce((total, producto) => total + parseInt(producto.cantidad), 0)}</div>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                ) : (
                  <div>
                    <Col xl={12} l={12} m={12} s={12} className="center-align">
                      <h5 className="titulo-pedido">
                        Selecciona al menos un articulo antes de colocar tu
                        pedido!
                      </h5>
                    </Col>
                    <Col xl={12} l={12} m={12} s={12} className="center">
                      <Button large onClick={this.props.regresarArticulos}>
                        Regresar a los articulos
                      </Button>
                    </Col>
                  </div>
                )}
              </Row>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export { PedidoView as default };
